/* eslint-disable unicorn/prefer-temporal -- Date is the type consumed by formatDate/sortByDate and the wider UI; migrating to Temporal is a separate change */
export class BaseModel {
    public created_at: Date = new Date(0);
    public updated_at: Date = new Date(0);

    public convertDates(): void {
        this.created_at = new Date(this.created_at);
        this.updated_at = new Date(this.updated_at);
    }

    public wrap(object: unknown): this {
        Object.assign(this, object);
        this.convertDates();
        return this;
    }
}
